import React, { useState } from "react";
import "./Header.css";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/img/logo-wide.png"; // Adjust the path as necessary

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("English");

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
  };
  return (
    <header className="header">
      <div className="logo">
       <a href="/"> <img src={logo} alt="logo" className="logo-big" /></a>
      </div>
      <nav className={`nav ${isMenuOpen ? "open" : ""}`}>
        <ul>
          <li className="alinks">
            <NavLink to="/terms-of-service">Terms of Service</NavLink>{" "}
          </li>
          <li className="alinks">
            <NavLink to="/privacy-policy">Privacy Policy</NavLink>
          </li>
          <li>
            <select
              className="language-select"
              value={selectedLanguage}
              onChange={handleLanguageChange}
            >
              <option value="English">English</option>
              <option value="French">French</option>
            </select>
          </li>
        </ul>
      </nav>
      <div
        className={`hamburger ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
    </header>
  );
};

export default Header;
